import { gql } from 'graphql-request';

export type SiteFilterCountry = {
    code: string;
    name: string;
};

export type SiteFilterIsicCode = {
    code: string;
    description: string;
};

export type SiteFilterOptions = {
    countries: SiteFilterCountry[];
    isicCodes: SiteFilterIsicCode[];
};

export type SiteFilterOptionsResult = {
    organisation: {
        siteFilterOptions: SiteFilterOptions;
    };
};

export const siteFilterOptionsQuery = gql`
    query SiteFilterOptions($businessCentralId: String!) {
        organisation(businessCentralId: $businessCentralId) {
            siteFilterOptions {
                countries {
                    code
                    name
                }
                isicCodes {
                    code
                    description
                }
            }
        }
    }
`;
